const DeleteOutlined = ({ size = 16, color = '#25314C' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    fill='none'
    viewBox='0 0 16 17'
  >
    <path
      fill={color}
      d='M14 4h-2.373c-.6 0-.626-.076-.79-.57l-.135-.404A1.5 1.5 0 0 0 9.279 2H6.721c-.647 0-1.219.412-1.423 1.026l-.135.405C5 3.925 4.973 4 4.373 4H2a.5.5 0 0 0 0 1h.865l.512 7.666C3.475 14.149 4.385 15 5.87 15h4.258c1.486 0 2.396-.85 2.495-2.334L13.135 5H14a.5.5 0 0 0 0-1m-7.753-.658A.5.5 0 0 1 6.72 3h2.558c.216 0 .406.137.474.342l.135.405q.044.131.09.253H6.02q.048-.123.091-.253zm5.378 9.257c-.063.956-.539 1.401-1.496 1.401H5.87c-.958 0-1.433-.445-1.497-1.4L3.867 5h.505c.083 0 .153-.009.227-.014.023.003.044.014.067.014h6.667c.024 0 .044-.01.066-.014.075.005.144.014.228.014h.504zM9.833 7.833v3.334a.5.5 0 0 1-1 0V7.833a.5.5 0 0 1 1 0m-2.666 0v3.334a.5.5 0 0 1-1 0V7.833a.5.5 0 0 1 1 0'
    />
  </svg>
);

export default DeleteOutlined;
